import { defineMessages } from 'react-intl';

export default defineMessages({
  cvvTooltipMessage: {
    id: 'CloverInput.cvvTooltipMessage',
    defaultMessage:
      'The CVV (credit card identification number) is an added safeguard for your credit card purchases. Depending on the type of credit card you use, it is the 3- or 4-digit number printed on the back or front of your credit card.',
  },
});